import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Logo from "../assets/images/logo.svg";
import { toast, ToastContainer } from "react-toastify";
import { Url } from "../config/config";
import axios from "axios";

export default function Login() {
  const history = useNavigate();
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setError] = useState({ newPassword: "", confirmPassword: "" });

  //****************Handel Validation************************ */
  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    if (!newPassword) {
      formIsValid = false;
      errors["newPassword"] = "Please enter new password";
    }
    if (!confirmPassword) {
      formIsValid = false;
      errors["confirmPassword"] = "Please enter confirm password";
    }

    if (confirmPassword != newPassword) {
      formIsValid = false;
      errors["confirmPassword"] =
        "Confirm password must be equal to new password";
    }
    setError(errors);
    return formIsValid;
  };

  //********************Update Password******************************* */
  const UpdatePassword = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      const res = await axios({
        url: `${Url}/changepasswordviaEmail?token=${token}`,
        method: "POST",

        // Attaching the form data
        data: {
          confirmPassword,
          newPassword,
        },
      });
      console.log("res", res);
      if (res.data.status == 200) {
        history("/");
      } else {
        toast.error(res.data.message);
        console.log(res.data.message);
      }
    }
    //
  };
  return (
    <React.Fragment>
      <div className="LoginArea">
        <form method="POST">
          <div className="LoginBox">
            <figure>
              <img src={Logo} />
            </figure>
            <h5>Reset Password</h5>
            {/* <h6>
              To keep connected wit us please login<br></br> wit your personal
              info.
            </h6> */}

            <div className="form-group">
              <label>New Password</label>
              <input
                type="password"
                placeholder="New Password"
                className="form-control"
                name="mewPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <span style={{ color: "red" }}>{errors.newPassword}</span>
            </div>

            <div className="form-group">
              <label>Confirm Password</label>
              <input
                type="password"
                placeholder="Confirm Password"
                className="form-control"
                name="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <span style={{ color: "red" }}>{errors.confirmPassword}</span>
            </div>

            <button className="button" onClick={UpdatePassword}>
              Update Password <i className="fa fa-sign-in"></i>
            </button>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
}
